import Organizations_Workspace_WorkspaceInvitationPage from "@Organizations/Workspaces/Pages/WorkspaceInvitationPage.vue";
import Organizations_Workspace_Admin_CreateWorkspacePage from "@Organizations/Workspaces/Pages/Admin/CreateWorkspacePage.vue";
import Organizations_Workspace_Admin_ManageWorkspacePage from "@Organizations/Workspaces/Pages/Admin/ManageWorkspacePage.vue";
import Organizations_Workspace_Admin_ManageWorkspacesPage from "@Organizations/Workspaces/Pages/Admin/ManageWorkspacesPage.vue";
import Organizations_Workspace_AdminEditWorkspacePage from "@Organizations/Workspaces/Pages/AdminEditWorkspacePage.vue";

export const routes = [
    {
        path: "/organizations/workspaces/invitation/:token",
        component: Organizations_Workspace_WorkspaceInvitationPage
    },
    {
        path: "/admin/organizations/workspaces/:tid",
        component: Organizations_Workspace_Admin_ManageWorkspacesPage
    },
    {
        path: "/admin/organizations/workspaces/create/:tid",
        component: Organizations_Workspace_Admin_CreateWorkspacePage
    },
    {
        path: "/admin/organizations/workspaces/manage/:id",
        component: Organizations_Workspace_Admin_ManageWorkspacePage
    },
    {
        path: "/admin/organizations/workspaces/edit/:id",
        component: Organizations_Workspace_AdminEditWorkspacePage
    }
]
